import { ReceiptLineCountComponent } from './receipt-line-count.component';

export default angular
  .module('sfMobile.components.receipt-line-count', [
    'sfMobile.constants.question-product',
    'sfMobile.components.receipt-line-product',
  ])
  .component('sfReceiptLineCount', ReceiptLineCountComponent).name;
